export const articles = [
  {
    id: 1,
    title: '辛亥革命：终结千年帝制的伟大革命',
    slug: 'xinhai-revolution-1911',
    summary: '1911年爆发的辛亥革命，是中国近代史上最伟大的变革之一。它不仅推翻了延续两千多年的封建帝制，更开创了亚洲第一个民主共和国的先河，深刻改变了中国的政治格局和世界历史进程。',
    content: `<p>1911年10月10日，武昌城头的枪声划破了中国两千多年封建帝制的沉寂夜空。这场被后世称为"辛亥革命"的伟大革命，以摧枯拉朽之势席卷全国，最终在短短数月内推翻了清王朝的统治。</p>
<h3>革命背景</h3>
<p>19世纪末至20世纪初，清王朝在内外交困中日益衰落。甲午战争的惨败、八国联军的入侵、《辛丑条约》的签订，一系列丧权辱国的事件让中国民众对清政府的统治彻底丧失信心。与此同时，西方民主思想通过留学生和进步知识分子传入中国，孙中山先生提出的"三民主义"成为革命的思想基础。</p>
<h3>革命进程</h3>
<p>1911年5月，清政府宣布铁路国有化政策，引发了声势浩大的保路运动。四川保路运动的爆发成为革命的导火索。10月10日，湖北新军中的革命党人在武昌发动起义，迅速占领武汉三镇。随后，湖南、陕西、江西、山西、云南等省份纷纷响应，宣布独立。</p>
<h3>历史意义</h3>
<p>辛亥革命终结了中国长达2132年的封建帝制，建立了亚洲第一个民主共和国——中华民国。它不仅改变了中国的政治体制，更深刻影响了整个亚洲的民族解放运动。列宁曾高度评价辛亥革命，称其为"亚洲的觉醒"。</p>
<p>虽然辛亥革命未能彻底改变中国半殖民地半封建的社会性质，但它播下的民主共和种子，为此后中国的社会变革奠定了重要基础。这场革命所体现的爱国精神和革命勇气，至今仍激励着无数人。</p>`,
    category: 'politics',
    date: '1911-10-10',
    imageUrl: 'https://readdy.ai/api/search-image?query=Xinhai%20Revolution%201911%20historical%20moment%2C%20soldiers%20raising%20flag%20on%20Wuchang%20city%20wall%2C%20dramatic%20lighting%2C%20warm%20golden%20tones%2C%20classical%20Chinese%20painting%20style%20with%20modern%20realistic%20rendering&width=800&height=480&seq=article-card-1&orientation=landscape',
    tags: ['辛亥革命', '清朝灭亡', '民主革命', '孙中山', '武昌起义'],
    featured: true,
    readTime: 8,
  },
  {
    id: 2,
    title: '柏林墙倒塌：冷战终结的象征',
    slug: 'berlin-wall-fall-1989',
    summary: '1989年11月9日，柏林墙的轰然倒塌标志着冷战时代的终结。这道分割东西方世界长达28年的混凝土屏障的崩塌，不仅改变了德国的命运，更重塑了整个世界的政治格局。',
    content: `<p>1989年11月9日晚上，当东德政府发言人君特·沙博夫斯基在一次新闻发布会上模糊地宣布新的旅行法规时，没有人预料到接下来的历史性时刻。成千上万的东柏林市民涌向边境检查站，面对不知所措的边防士兵，这道象征冷战分裂的柏林墙终于在这一夜轰然倒塌。</p>
<h3>柏林墙的历史</h3>
<p>1961年8月13日，东德政府在一夜之间竖起了柏林墙。这道全长155公里的隔离设施，不仅是一道物理屏障，更是意识形态对立的象征。在28年的历史中，至少有140人在试图翻越柏林墙时失去了生命。</p>
<h3>倒塌的原因</h3>
<p>20世纪80年代后期，苏联领导人戈尔巴乔夫推行的改革政策（"公开性"和"改革"）在东欧产生了深远影响。东欧各国纷纷出现民主化浪潮，匈牙利率先开放了与奥地利的边境，大量东德公民通过匈牙利逃往西方。与此同时，东德国内的反政府示威活动愈演愈烈，莱比锡等城市的"星期一示威"规模不断扩大。</p>
<h3>历史影响</h3>
<p>柏林墙的倒塌成为冷战结束的最强象征。1990年10月3日，两德正式统一。这一事件加速了苏联解体和东欧剧变的进程，世界从两极对峙走向了多极化格局。</p>
<p>今天，柏林墙的残骸散落在世界各地，成为人们对自由和统一的永恒纪念。它提醒着世人：任何试图禁锢人类自由的高墙，终将在历史的洪流中倒塌。</p>`,
    category: 'politics',
    date: '1989-11-09',
    imageUrl: 'https://readdy.ai/api/search-image?query=Berlin%20Wall%20falling%20at%20night%2C%20crowds%20celebrating%20on%20top%20of%20wall%20with%20hammers%2C%20Brandenburg%20Gate%20in%20background%2C%20warm%20street%20lights%2C%20emotional%20historical%20moment%2C%20photorealistic%20documentary%20style&width=800&height=480&seq=article-card-2&orientation=landscape',
    tags: ['柏林墙', '冷战', '德国统一', '东欧剧变', '1989'],
    featured: true,
    readTime: 7,
  },
  {
    id: 3,
    title: '1929年经济大萧条：全球经济体系的崩裂',
    slug: 'great-depression-1929',
    summary: '1929年10月24日"黑色星期四"，华尔街股市崩盘引发了人类历史上最严重的经济危机。这场大萧条席卷全球，导致数千万人失业，深刻改变了经济理论和政府治理模式。',
    content: `<p>1929年10月24日，纽约证券交易所的交易大厅陷入了一片恐慌。股票价格如自由落体般暴跌，投资者疯狂抛售手中的股票，这一天被永远地铭记为"黑色星期四"。随后的"黑色星期一"和"黑色星期二"彻底击垮了市场信心，一场前所未有的经济危机就此拉开帷幕。</p>
<h3>危机的根源</h3>
<p>20世纪20年代，美国经济经历了"咆哮的二十年代"的繁荣期。然而，这种繁荣背后隐藏着巨大的泡沫：过度的股票投机、严重的贫富分化、农业生产过剩以及脆弱的国际金融体系。当泡沫破裂时，整个经济体系如同多米诺骨牌般崩塌。</p>
<h3>全球蔓延</h3>
<p>大萧条迅速从美国蔓延至全球。德国的失业率一度高达30%，英国和法国的工业生产大幅下降，拉丁美洲的原材料出口遭受重创。全球贸易额从1929年的686亿美元骤降至1933年的242亿美元，国际贸易体系几乎陷入瘫痪。</p>
<h3>应对与影响</h3>
<p>美国总统富兰克林·罗斯福上台后推行的"新政"，开创了政府大规模干预经济的先河。凯恩斯经济学说因此获得广泛认同，政府通过财政政策和公共工程来刺激经济成为主流做法。</p>
<p>大萧条深刻地改变了人们对资本主义的认知。它催生了社会保障体系的建立，推动了金融监管的完善，也为第二次世界大战的爆发埋下了伏笔。这场危机告诉我们：不受监管的市场繁荣终将走向自我毁灭。</p>`,
    category: 'economy',
    date: '1929-10-24',
    imageUrl: 'https://readdy.ai/api/search-image?query=1929%20Wall%20Street%20stock%20market%20crash%2C%20black%20and%20white%20historical%20scene%2C%20panicked%20crowd%20outside%20New%20York%20Stock%20Exchange%2C%20vintage%20suits%20and%20fedora%20hats%2C%20dramatic%20shadows%2C%20Great%20Depression%20era%20aesthetic&width=800&height=480&seq=article-card-3&orientation=landscape',
    tags: ['大萧条', '经济危机', '华尔街崩盘', '罗斯福新政', '1929'],
    featured: true,
    readTime: 9,
  },
  {
    id: 4,
    title: '中国改革开放：改变十三亿人命运的伟大抉择',
    slug: 'china-reform-opening-1978',
    summary: '1978年12月，中国共产党十一届三中全会的召开，标志着中国改革开放的伟大征程正式开启。这场深刻的社会变革，在短短四十年间将一个贫穷落后的国家转变为世界第二大经济体。',
    content: `<p>1978年12月18日至22日，中国共产党第十一届中央委员会第三次全体会议在北京召开。这次会议成为中国现代史上一个决定性的转折点，它结束了"以阶级斗争为纲"的路线，将党和国家的工作重心转移到经济建设上来。</p>
<h3>改革的序幕</h3>
<p>1978年，安徽凤阳小岗村的18位农民在一张皱巴巴的纸上按下了红手印，秘密实行"包产到户"。这个被视为"冒天下之大不韪"的举动，成为中国农村改革的起点。随后，家庭联产承包责任制在全国推广，极大地激发了农民的生产积极性。</p>
<h3>开放的步伐</h3>
<p>1979年，深圳、珠海、汕头、厦门四个经济特区的设立，打开了中国对外开放的窗口。外资的引入、技术的引进、管理经验的借鉴，为中国经济注入了前所未有的活力。深圳从一个小渔村迅速崛起为国际化大都市，"深圳速度"成为改革开放的生动注脚。</p>
<h3>深远影响</h3>
<p>改革开放四十余年来，中国经济年均增长超过9%，超过7亿人口摆脱贫困。中国从一个封闭落后的农业国成长为世界制造业大国和全球第二大经济体。这场变革不仅改变了中国的命运，也深刻影响了世界经济格局。</p>
<p>改革开放的伟大实践告诉我们：顺应时代潮流、尊重人民首创精神、坚持走自己的道路，是一个国家和民族走向繁荣富强的根本保证。</p>`,
    category: 'economy',
    date: '1978-12-18',
    imageUrl: 'https://readdy.ai/api/search-image?query=Shenzhen%20skyline%20transformation%20from%201978%20to%20modern%20day%2C%20split%20composition%20showing%20old%20fishing%20village%20to%20modern%20skyscrapers%2C%20warm%20golden%20hour%20light%2C%20hopeful%20atmosphere&width=800&height=480&seq=article-card-4&orientation=landscape',
    tags: ['改革开放', '十一届三中全会', '经济特区', '邓小平', '1978'],
    featured: true,
    readTime: 8,
  },
  {
    id: 5,
    title: '五四运动：新文化运动的曙光',
    slug: 'may-fourth-movement-1919',
    summary: '1919年爆发的五四运动，是中国近代史上一次彻底的反帝反封建的爱国运动。它不仅是政治抗议，更是一场思想启蒙运动，深刻影响了中国现代文化和教育的发展方向。',
    content: `<p>1919年5月4日，北京大学的数千名学生走出校园，走上街头，高喊"外争主权，内惩国贼"的口号，抗议巴黎和会上中国外交的失败。这场由青年学生发起的爱国运动迅速席卷全国，成为中国近代史上一个具有里程碑意义的事件。</p>
<h3>历史背景</h3>
<p>第一次世界大战结束后，中国作为战胜国参加巴黎和会，期望收回德国在山东的权益。然而，列强无视中国的正当要求，将山东权益转让给日本。消息传回国内，激起了全国人民的极大愤慨。</p>
<h3>运动的发展</h3>
<p>学生运动很快得到了工人、商人等社会各界的响应。上海等地爆发了大规模的罢工和罢市斗争，运动从学生运动发展为全国性的群众运动。在强大的社会压力下，北洋政府最终拒绝在巴黎和约上签字。</p>
<h3>文化影响</h3>
<p>五四运动不仅是一场政治运动，更是一场深刻的文化革命。它推动了白话文运动，促进了新文学的发展，传播了民主与科学的思想。陈独秀、李大钊、胡适、鲁迅等一批知识分子成为新文化运动的旗手。</p>
<p>五四精神——爱国、进步、民主、科学——成为中国现代文化的重要组成部分，影响了一代又一代的中国青年。</p>`,
    category: 'society',
    date: '1919-05-04',
    imageUrl: 'https://readdy.ai/api/search-image?query=May%20Fourth%20Movement%201919%2C%20students%20marching%20on%20Beijing%20streets%20with%20banners%2C%20early%2020th%20century%20Chinese%20students%20in%20traditional%20clothing%2C%20passionate%20expressions%2C%20sepia%20warm%20tones&width=800&height=480&seq=article-card-5&orientation=landscape',
    tags: ['五四运动', '新文化运动', '爱国运动', '民主科学', '1919'],
    featured: false,
    readTime: 7,
  },
  {
    id: 6,
    title: '人类首次登月："这是个人的一小步，人类的一大步"',
    slug: 'moon-landing-1969',
    summary: '1969年7月20日，美国宇航员尼尔·阿姆斯特朗踏上月球表面，实现了人类数千年来登陆月球的梦想。阿波罗11号任务不仅是太空竞赛的巅峰，更是人类科技史上最伟大的成就之一。',
    content: `<p>1969年7月20日协调世界时20时17分40秒，阿波罗11号登月舱"鹰"号在月球表面的静海基地成功着陆。六个多小时后，指令长尼尔·阿姆斯特朗缓缓走下扶梯，在月球表面留下了人类的第一个足迹。那一刻，全球约6亿人通过电视直播见证了这一历史性时刻。</p>
<h3>太空竞赛的背景</h3>
<p>登月计划诞生于美苏冷战时期的太空竞赛。1957年苏联成功发射第一颗人造卫星斯普特尼克1号，1961年尤里·加加林成为第一个进入太空的人类，苏联在太空探索的早期阶段遥遥领先。1961年，美国总统肯尼迪宣布了"在这个十年结束前将人类送上月球"的宏伟目标。</p>
<h3>阿波罗11号任务</h3>
<p>阿波罗11号于1969年7月16日从肯尼迪航天中心发射升空，乘员包括指令长尼尔·阿姆斯特朗、指令舱驾驶员迈克尔·科林斯和登月舱驾驶员巴兹·奥尔德林。经过四天的飞行，登月舱成功在月球表面着陆。阿姆斯特朗和奥尔德林在月球表面停留了约2小时31分钟，采集了21.5千克的月球样本。</p>
<h3>科技与人文的双重意义</h3>
<p>阿波罗计划推动了计算机、通信、材料科学等众多领域的巨大进步。集成电路、卫星通信、冷冻干燥食品等技术的快速发展，都直接或间接得益于太空探索。</p>
<p>而从人文角度来看，登月让人类第一次从月球回望地球，那张著名的"地出"照片深刻地改变了人类对自身和家园的认知——在浩瀚宇宙中，地球不过是一颗脆弱的蓝色弹珠。登月不仅是美国的胜利，更是全人类的胜利。</p>`,
    category: 'technology',
    date: '1969-07-20',
    imageUrl: 'https://readdy.ai/api/search-image?query=Apollo%2011%20astronaut%20standing%20on%20lunar%20surface%2C%20Earth%20visible%20in%20dark%20sky%20background%2C%20dramatic%20lighting%20on%20moon%20surface%2C%20iconic%20spacesuit%20with%20golden%20visor%2C%20photorealistic%20space%20photography&width=800&height=480&seq=article-card-6&orientation=landscape',
    tags: ['登月', '阿波罗计划', '太空竞赛', '阿姆斯特朗', '1969'],
    featured: true,
    readTime: 9,
  },
  {
    id: 7,
    title: '工业革命：人类生产力的大跃迁',
    slug: 'industrial-revolution',
    summary: '18世纪从英国开始的工业革命，是人类历史上最重要的转折点之一。蒸汽机的轰鸣声不仅改变了生产方式，更彻底重塑了社会结构、城市形态和人类的生活方式。',
    content: `<p>18世纪60年代，英伦三岛上响起了蒸汽机的轰鸣声，一场前所未有的变革正在悄然发生。这场后来被称为"工业革命"的巨大变革，从生产技术领域开始，逐渐扩展到社会、经济、文化的方方面面，深刻改变了人类文明的进程。</p>
<h3>技术突破</h3>
<p>工业革命的核心在于一系列关键的技术创新。1765年，詹姆斯·瓦特改良了蒸汽机，使其效率大幅提高，为机械化生产提供了强大的动力。纺织领域，飞梭、珍妮纺纱机、水力纺纱机等发明相继问世，使纺织业从手工作坊走向工厂化生产。交通运输方面，蒸汽机车和蒸汽船的发明极大地缩短了时空距离。</p>
<h3>社会变革</h3>
<p>工业革命催生了全新的社会阶级——工业资产阶级和工业无产阶级。大量农民离开土地涌入城市，城市规模急剧膨胀。曼彻斯特、伯明翰等工业城市迅速发展为人口密集的制造业中心。工厂制度的建立改变了千百年来的工作方式，时钟和纪律成为工人生活的一部分。</p>
<h3>全球影响</h3>
<p>工业革命从英国蔓延至欧洲大陆、北美，最终扩展到全世界。它使西方国家的生产力实现了质的飞跃，拉开了与非西方世界的巨大差距。这种差距在19世纪转化为殖民扩张的动力，深刻影响了此后两个世纪的世界格局。</p>
<p>工业革命是一把双刃剑：它带来了前所未有的物质繁荣，也带来了环境污染、工人剥削、社会不平等等问题。这些问题至今仍是人类社会面临的挑战。</p>`,
    category: 'technology',
    date: '1760-01-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=British%20Industrial%20Revolution%20scene%2C%20steam%20locomotives%20and%20factory%20smokestacks%20in%20Victorian%20era%20Manchester%2C%20warm%20sepia%20tones%2C%20atmospheric%20industrial%20smog%20with%20golden%20sunset%20light&width=800&height=480&seq=article-card-7&orientation=landscape',
    tags: ['工业革命', '蒸汽机', '工厂制度', '城市化', '瓦特'],
    featured: false,
    readTime: 8,
  },
  {
    id: 8,
    title: '第一次世界大战：终结旧世界的浩劫',
    slug: 'world-war-one',
    summary: '1914年至1918年的第一次世界大战，是人类历史上第一次全球性的大规模军事冲突。这场战争摧毁了四大帝国，改写了世界版图，也深刻改变了战争形态和人类的战争观念。',
    content: `<p>1914年6月28日，奥匈帝国皇储弗朗茨·斐迪南大公在波斯尼亚首都萨拉热窝遇刺身亡。这一事件引爆了欧洲各国之间错综复杂的同盟体系，将整个欧洲大陆拖入了战争的深渊。没有人预料到，这场最初被认为是"圣诞节前就能结束"的战争，将持续四年之久，夺去超过1600万人的生命。</p>
<h3>战争的根源</h3>
<p>一战的爆发并非偶然。19世纪末至20世纪初，欧洲列强之间的帝国主义竞争日益激烈。德国统一后的迅速崛起挑战了英国的霸权地位，法德之间的阿尔萨斯-洛林争端持续发酵，奥匈帝国与俄罗斯在巴尔干半岛的争夺不断升级。同盟国与协约国两大军事集团的形成，使任何局部冲突都可能演变为全面战争。</p>
<h3>战争的进程</h3>
<p>战争初期，各国都以为这将是一场速决战。然而，马恩河战役后，西线陷入了长达四年的战壕战僵局。索姆河战役中，英军第一天就损失了近6万人。凡尔登战役持续了10个月，双方伤亡超过70万人。新式武器——机枪、毒气、坦克、飞机——被大规模投入战场，战争的残酷性达到了前所未有的程度。</p>
<h3>战争的结局</h3>
<p>1918年11月11日，德国签署停战协定，一战结束。德意志帝国、奥匈帝国、俄罗斯帝国、奥斯曼帝国四大帝国相继崩溃。战后签订的《凡尔赛条约》对德国施加了严厉的惩罚，为二十年后第二次世界大战的爆发埋下了伏笔。</p>
<p>一战宣告了旧欧洲秩序的终结，也开启了人类反思战争、追求和平的新纪元。</p>`,
    category: 'military',
    date: '1914-07-28',
    imageUrl: 'https://readdy.ai/api/search-image?query=World%20War%20One%20trench%20warfare%20scene%2C%20soldiers%20in%20muddy%20trenches%20with%20gas%20masks%2C%20dramatic%20overcast%20sky%20with%20searchlights%2C%20barbed%20wire%20and%20no%20mans%20land%2C%20muted%20earth%20tones&width=800&height=480&seq=article-card-8&orientation=landscape',
    tags: ['第一次世界大战', '萨拉热窝事件', '凡尔赛条约', '战壕战', '1914'],
    featured: true,
    readTime: 9,
  },
  {
    id: 9,
    title: '2008全球金融危机：华尔街引发的世界性衰退',
    slug: '2008-financial-crisis',
    summary: '2008年，由美国次贷危机引发的全球金融海啸，是自1929年大萧条以来最严重的经济衰退。雷曼兄弟的倒闭成为危机的标志性事件，全球金融体系一度濒临崩溃。',
    content: `<p>2008年9月15日，拥有158年历史的华尔街巨头雷曼兄弟申请破产保护，成为美国历史上最大的破产案。这一事件如同引爆了一颗金融核弹，全球金融市场应声暴跌，一场自大萧条以来最严重的经济危机全面爆发。</p>
<h3>危机的根源</h3>
<p>危机的种子早在21世纪初就已埋下。在低利率环境和金融自由化浪潮下，美国的房地产市场经历了前所未有的繁荣。银行和金融机构向信用记录不佳的借款人发放了大量次级抵押贷款，并将这些贷款通过复杂的金融衍生品包装后出售给全球投资者。当利率上升、房价下跌时，次贷违约潮爆发，建立在次贷之上的金融大厦轰然倒塌。</p>
<h3>全球蔓延</h3>
<p>由于全球金融体系的深度互联，危机迅速从美国蔓延至全球。欧洲多家大型银行因持有大量美国次贷相关资产而陷入困境，冰岛甚至面临国家破产的危机。新兴经济体也未能幸免，全球贸易额急剧萎缩，大宗商品价格暴跌。</p>
<h3>应对与后果</h3>
<p>各国政府采取了前所未有的救市措施。美国推出了7000亿美元的问题资产救助计划，中国实施了四万亿经济刺激计划，各国央行纷纷大幅降息并实施量化宽松政策。这些措施虽然避免了金融体系的全面崩溃，但也带来了政府债务飙升、贫富差距扩大等长期问题。</p>
<p>2008年金融危机深刻地改变了人们对金融监管的认知。这场危机所揭示的贪婪、监管缺失和系统性风险，至今仍是悬在全球经济头上的达摩克利斯之剑。</p>`,
    category: 'economy',
    date: '2008-09-15',
    imageUrl: 'https://readdy.ai/api/search-image?query=2008%20financial%20crisis%20Wall%20Street%20scene%2C%20Lehman%20Brothers%20employees%20leaving%20office%20with%20cardboard%20boxes%2C%20modern%20glass%20skyscrapers%20under%20gloomy%20sky%2C%20photojournalism%20documentary%20style&width=800&height=480&seq=article-card-9&orientation=landscape',
    tags: ['金融危机', '次贷危机', '雷曼兄弟', '2008', '经济衰退'],
    featured: false,
    readTime: 8,
  },
  {
    id: 10,
    title: '互联网的诞生：连接世界的数字革命',
    slug: 'birth-of-internet',
    summary: '从1969年阿帕网的第一条信息，到万维网的诞生，再到今天万物互联的数字世界，互联网的发展史是人类信息传播史上最深刻的革命。它重新定义了沟通、商业和知识获取的方式。',
    content: `<p>1969年10月29日，加州大学洛杉矶分校的一台计算机向斯坦福研究院的另一台计算机发送了一条简短的消息："LOGIN"。虽然系统在传输到"G"时就崩溃了，但这标志着阿帕网——现代互联网的前身——的诞生。</p>
<h3>从军事项目到全球网络</h3>
<p>阿帕网最初是美国国防部高级研究计划局的一个军事项目，旨在建立一个分散化的通信网络，即使部分节点遭到核打击也能保持运作。TCP/IP协议在1983年成为阿帕网的标准协议，为不同网络之间的互联互通奠定了基础。</p>
<h3>万维网的诞生</h3>
<p>1989年，英国计算机科学家蒂姆·伯纳斯-李提出了万维网的概念。他发明了HTML语言、HTTP协议和URL地址系统，使互联网从技术专家的工具转变为普通人也能使用的信息平台。1993年，Mosaic浏览器的发布让图形化的网页浏览成为可能，互联网开始走向大众。</p>
<h3>数字革命的影响</h3>
<p>互联网深刻地改变了人类社会的方方面面。电子邮件取代了传统信件，搜索引擎让知识触手可及，电子商务重塑了零售业，社交媒体改变了人际交往的方式。进入21世纪，移动互联网的普及让"永远在线"成为常态。</p>
<p>互联网也带来了前所未有的挑战：信息过载、隐私泄露、虚假信息传播、数字鸿沟。这些问题提醒我们：技术是中性的，关键在于人类如何使用它。</p>`,
    category: 'technology',
    date: '1969-10-29',
    imageUrl: 'https://readdy.ai/api/search-image?query=Evolution%20of%20Internet%20concept%2C%20split%20composition%201960s%20mainframe%20computers%20to%20modern%20fiber%20optic%20global%20network%2C%20nodes%20and%20connections%2C%20warm%20golden%20and%20cool%20digital%20aesthetic&width=800&height=480&seq=article-card-10&orientation=landscape',
    tags: ['互联网', '阿帕网', '万维网', '数字革命', '蒂姆·伯纳斯-李'],
    featured: false,
    readTime: 8,
  },
  {
    id: 11,
    title: '联合国成立：世界和平的新希望',
    slug: 'united-nations-founding-1945',
    summary: '1945年10月24日，联合国正式成立。在两次世界大战的惨痛教训之后，国际社会终于建立起了一个旨在维护世界和平与安全的普遍性国际组织。',
    content: `<p>1945年6月26日，来自50个国家的代表在旧金山歌剧院签署了《联合国宪章》。10月24日，宪章获得足够数量的批准后正式生效，联合国宣告成立。这一天被定为"联合国日"。</p>
<h3>国联的教训</h3>
<p>联合国并非人类建立普遍性国际组织的首次尝试。第一次世界大战后成立的国际联盟，由于美国未加入、缺乏强制执行机制、成员国利益分歧等原因，未能阻止第二次世界大战的爆发。联合国的创始者们吸取了国联的教训，力图建立一个更有效的国际安全机制。</p>
<h3>联合国架构</h3>
<p>联合国设立了六大主要机构：大会、安全理事会、经济及社会理事会、托管理事会、国际法院和秘书处。其中，安理会被赋予维护国际和平与安全的首要责任，五个常任理事国——中国、法国、俄罗斯、英国和美国——拥有否决权。</p>
<h3>成就与挑战</h3>
<p>70多年来，联合国在维护和平、促进发展、保护人权等方面取得了重要成就。联合国维和行动在多个冲突地区发挥了稳定作用，世界卫生组织领导了全球公共卫生事业，联合国教科文组织推动了教育、科学和文化的国际合作。</p>
<p>然而，联合国也面临着大国博弈、改革滞后、资源不足等挑战。在全球化深入发展的今天，联合国能否适应新的国际格局，仍是一个待解的命题。</p>`,
    category: 'politics',
    date: '1945-10-24',
    imageUrl: 'https://readdy.ai/api/search-image?query=United%20Nations%20founding%20ceremony%201945%20San%20Francisco%2C%20delegates%20from%2050%20nations%20signing%20charter%20in%20grand%20opera%20house%2C%20flags%20of%20all%20nations%2C%20hopeful%20and%20solemn%20atmosphere&width=800&height=480&seq=article-card-11&orientation=landscape',
    tags: ['联合国', '国际组织', '二战', '世界和平', '1945'],
    featured: false,
    readTime: 7,
  },
  {
    id: 12,
    title: '第二次世界大战：人类历史上规模最大的浩劫',
    slug: 'world-war-two',
    summary: '1939年至1945年的第二次世界大战，是人类历史上规模最大、伤亡最惨重的全球性战争。61个国家和地区被卷入这场浩劫，超过7000万人失去生命，世界从此被彻底改变。',
    content: `<p>1939年9月1日，纳粹德国的军队越过波兰边境，第二次世界大战的帷幕就此拉开。在接下来的六年里，战火从欧洲蔓延到亚洲、非洲、大洋洲和各大洋，超过1亿军人被动员参战，战争的范围和惨烈程度超过了人类历史上的任何一次冲突。</p>
<h3>战争的根源</h3>
<p>第二次世界大战的根源可以追溯到一战结束后的安排。《凡尔赛条约》对战败国德国的严厉惩罚，激起了德国民众的强烈不满，为纳粹党的上台提供了土壤。1929年经济大萧条的冲击，使法西斯主义在德国、意大利和日本等国获得了广泛支持。英法等国的绥靖政策，未能阻止侵略者的野心。</p>
<h3>关键转折</h3>
<p>1941年，战争迎来了三大转折点。6月22日，纳粹德国发动"巴巴罗萨行动"入侵苏联，开辟了东线战场。12月7日，日本偷袭珍珠港，美国正式参战，战争真正成为全球性冲突。1942年至1943年，斯大林格勒战役的胜利成为欧洲战场的转折点，中途岛海战扭转了太平洋战场的态势。</p>
<h3>战争的影响</h3>
<p>二战以轴心国的彻底失败告终。1945年5月8日德国无条件投降，8月15日日本宣布投降。战争造成了约7000万至8500万人的死亡，其中包括约600万犹太人在纳粹大屠杀中遇难。原子弹的使用标志着人类进入了核时代。</p>
<p>二战彻底改变了世界格局：美国和苏联成为超级大国，冷战格局形成；殖民帝国走向瓦解，大批亚非拉国家获得独立；联合国成立，国际秩序进入新阶段。二战的教训警示人类：和平来之不易，必须共同守护。</p>`,
    category: 'military',
    date: '1939-09-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=World%20War%20Two%20D-Day%20Normandy%20landing%20scene%2C%20Allied%20soldiers%20storming%20beach%20under%20overcast%20sky%2C%20landing%20crafts%20in%20distance%2C%20dramatic%20atmosphere%2C%20muted%20olive%20and%20grey%20tones&width=800&height=480&seq=article-card-12&orientation=landscape',
    tags: ['第二次世界大战', '诺曼底登陆', '珍珠港', '原子弹', '冷战'],
    featured: true,
    readTime: 10,
  },
];

export const getArticlesByCategory = (slug: string) => {
  return articles.filter((article) => article.category === slug);
};

export const getFeaturedArticles = () => {
  return articles.filter((article) => article.featured);
};

export const getArticleById = (id: number) => {
  return articles.find((article) => article.id === id);
};

export const getRelatedArticles = (currentId: number, category: string) => {
  return articles
    .filter((article) => article.category === category && article.id !== currentId)
    .slice(0, 3);
};